export default "__VITE_ASSET__DAlQXogA__"